import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
    { q: t("faq.q5"), a: t("faq.a5") },
  ];

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="text-xs font-semibold tracking-wider uppercase text-primary-600">
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t("faq.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-xl border transition-all ${
                  open
                    ? "border-primary-200/60 bg-primary-50/40"
                    : "border-background-200/60 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {faq.q}
                  </span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                      open ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    <i
                      className={`${
                        open ? "ri-subtract-line" : "ri-add-line"
                      } text-lg`}
                    ></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}